import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

export default class extends Controller {
  confirmPrepayment(event) {
    event.preventDefault()
    const form = event.currentTarget
    if (!form.reportValidity()) return

    const amount = Number(form.querySelector("[name='amount']")?.value || 0)
    const currency = form.dataset.currency || "CAD"
    const region = form.dataset.regionName || "this region"
    const formatted = new Intl.NumberFormat("en-CA", { style: "currency", currency, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(amount)

    Swal.fire({
      icon: "question",
      title: `Record ${formatted} prepayment?`,
      text: `This will add the amount to the tracked ${region} AGCOD balance.`,
      showCancelButton: true,
      confirmButtonText: "Record prepayment",
      cancelButtonText: "Go back",
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) HTMLFormElement.prototype.submit.call(form)
    })
  }
}
